/*
 * Scene AOI Color Palette
 * Maps color names to hex codes for scene-specific AOI classification
 */

export interface SceneColor {
  name: string;
  hex: string;
}

export const sceneColors: SceneColor[] = [
  // Pink/Purple row
  { name: "Magenta", hex: "#F2318A" },
  { name: "Burgundy", hex: "#AF2780" },
  { name: "Purple", hex: "#9300E9" },
  { name: "Violet", hex: "#8636ED" },
  { name: "Indigo", hex: "#5C13B9" },

  // Blue row
  { name: "Blue", hex: "#0F6CEA" },
  { name: "Turquoise", hex: "#19B1D3" },
  { name: "Sea blue", hex: "#0078AF" },
  { name: "Ultramarine", hex: "#4166F5" },
  { name: "Navy blue", hex: "#290092" },

  // Green row
  { name: "Green", hex: "#76B71C" },
  { name: "Emerald", hex: "#00C148" },
  { name: "Mint", hex: "#00A851" },
  { name: "Forest green", hex: "#007635" },
  { name: "Moss green", hex: "#105200" },

  // Yellow/Brown/Black row
  { name: "Yellow", hex: "#D4BC00" },
  { name: "Bronze", hex: "#C17700" },
  { name: "Red", hex: "#E31B23" },
  { name: "Brown", hex: "#A43F1D" },
  { name: "Gray", hex: "#1B1B1D" },
];

/*
 * Get color name by hex code
 */
export const getColorNameByHex = (hex: string): string => {
  const color = sceneColors.find((color) => color.hex.toLowerCase() === hex.toLowerCase());
  return color?.name || "Unknown";
};

/*
 * Get color hex by name
 */
export const getColorHexByName = (name: string): string => {
  const color = sceneColors.find((color) => color.name.toLowerCase() === name.toLowerCase());
  return color?.hex || "#1B1B1D";
};

